import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {

    async [actionTypes.SERVICO.BUSCAR_TODOS_SERVICOS]({state}) {
        const {filtros, paginacao} = state.resultadoBuscaTodosServicos
        const {data} = await api.servico.buscarTodos(filtros, paginacao)
        return data
    },

    async [actionTypes.SERVICO.CADASTRAR_SERVICO](context, dados) {
        const {data} = await api.servico.cadastrar(dados)
        return data
    },

    async [actionTypes.SERVICO.EDITAR_SERVICO](context, dados) {
        const {data} = await api.servico.editar(dados)
        return data
    },

    async [actionTypes.SERVICO.EXCLUIR_SERVICO](context, id) {
        await api.servico.excluir(id)
    },

}